import { render } from "./thinktank-submissions.vue?vue&type=template&id=d7b891e6"
import script from "./thinktank-submissions.vue?vue&type=script&lang=js"
export * from "./thinktank-submissions.vue?vue&type=script&lang=js"
script.render = render

export default script